export default __webpack_public_path__ + "static/media/gratitude.0aa3ffa8.svg";